import { inject, Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { COMMONS_ENV, ObservableQueryService } from '@damofire/data-angular-commons';
import { Dto, LAYOUT_TEXTS_COLLECTION, OUTLINE_COLLECTION, Query, SearchResult, WW_WAREHOUSES_COLLECTION } from '@damofire/data-commons';
import { LayoutTextSegment, Warehouse, WarehouseOutlineSegment } from './warehouse.dto';
import { WarehouseService } from './warehouse.service';

@Injectable()
export class FirebaseWarehouseService extends WarehouseService {
  private readonly firestore = inject(Firestore);
  protected readonly environment = inject(COMMONS_ENV);
  private readonly firestoreQueryService = inject(ObservableQueryService);

  constructor() {
    super(inject(COMMONS_ENV));
  }

  async get(id: string): Promise<Warehouse> {
    const docRef = doc(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${id}`);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      return { ...(snapshot.data() as Warehouse), _id: snapshot.id } as Warehouse;
    }
    return null;
  }

  async search(query: Query): Promise<SearchResult<Warehouse>> {
    return this.firestoreQueryService.collection<Warehouse>(WW_WAREHOUSES_COLLECTION, query);
  }

  async reloadOutlines(): Promise<void> {
    const collectionRef = collection(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${this.divisionId}/${OUTLINE_COLLECTION}`);
    const snapshot = await getDocs(collectionRef);
    this.outlines = snapshot.docs.map((doc) => ({ ...(doc.data() as WarehouseOutlineSegment), _id: doc.id }) as WarehouseOutlineSegment);
  }

  async reloadLayoutTexts(): Promise<void> {
    const collectionRef = collection(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${this.divisionId}/${LAYOUT_TEXTS_COLLECTION}`);
    const snapshot = await getDocs(collectionRef);
    this.texts = snapshot.docs.map((doc) => ({ ...(doc.data() as LayoutTextSegment), _id: doc.id }) as LayoutTextSegment);
  }

  async getOfflineWarehouses(): Promise<Dto<string>[]> {
    throw new Error('Not implemented');
  }
}
